// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import Collapse from '@kunukn/react-collapse'

const item = {
  content: [
    { info: 'Você pode entrar em contato conosco através dos canais:',
      atendimento: [
        {
          title: '- Mensageria',
          number: '',
          mensagem: [
            {
              item: 'Atendimento em dias úteis, das 8h às 18h. Respostas em até 2 dias úteis.'
            }
          ],
          link: ''
        },
        {
          title: '-  Itaú Empresas no telefone',
          number: '0300 100 7575',
          mensagem: [
            {
              item: 'Para todas as localidades'
            },
            {
              item: 'Atendimento em dias úteis, das 7h às 20h.'
            }
          ],
          link: ''
        },
        {
          title: '- SAC',
          number: '0800 728 0728',
          mensagem: '',
          link: ''
        },
        {
          title: '- Ouvidoria',
          number: '0800 570 0011',
          mensagem: [
            {
              item: 'Todas as localidades'
            }
          ],
          link: ''
        },
        {
          title: '',
          number: '0800 722 1722',
          mensagem: [
            {
              item: 'Deficientes auditivos/ fala'
            },
            {
              item: 'Para todas as localidades.'
            }
          ],
          link: ''
        }
      ]
    }
  ]
}

class HelpItem extends React.Component {
  state = {
    isOpen: false
  };

  render () {
    return (
      <div className='items'>
        <div className={cx('app__toggle head item', { 'app__toggle--active head item': this.state.isOpen })} onClick={() => this.toggle(2)}>
          <span className='number'>5</span>
          <label htmlFor=''>Canais de atendimento</label>
          <i className={this.state.isOpen ? 'icon icon_arrow_up' : 'icon icon_arrow_down'} />
        </div>

        <Collapse
          isOpen={this.state.isOpen}
          className={'app__collapse app__collapse--gradient ' + (this.state.isOpen ? 'app__collapse--active' : '')}
          transition='height 800ms cubic-bezier(0.4, 0, 0.2, 1)'
          aria-hidden={this.state.isOpen ? 'false' : 'true'}
          elementType='article'
          render={collapseState => (
            <React.Fragment>
              <div className='app__content content'>
                { item.content && item.content.map((item, index) => (
                  <div key={index}>
                    <p>{ item.info }</p>
                    { item.atendimento && item.atendimento.map((item, index) => (
                      <div className='item'>
                        <p className={item.title && 'title'} >{ item.title }</p>
                        <p className={item.number && 'number'} >{ item.number }</p>
                        { item.mensagem && item.mensagem.map((item, index) => (
                          <p className={item.item && 'mensagem'} >{ item.item }</p>
                        ))}
                      </div>
                    )) }
                  </div>
                ))}
              </div>
            </React.Fragment>
          )}
        />
      </div>
    )
  }

  toggle = index => {
    let collapse = 'isOpen'

    this.setState(prevState => ({ [collapse]: !prevState[collapse] }))
  };
}

export default HelpItem



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/components/HelpItens/HelpItem5.js